import { render, staticRenderFns } from "./TabelaInfosPublicasBndesPj.vue?vue&type=template&id=f764e762&lang=pug"
import script from "./TabelaInfosPublicasBndesPj.vue?vue&type=script&lang=js"
export * from "./TabelaInfosPublicasBndesPj.vue?vue&type=script&lang=js"
import style0 from "./TabelaInfosPublicasBndesPj.vue?vue&type=style&index=0&id=f764e762&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports